import { Link } from "react-router-dom";
import {AuthStudent, AuthTeacher} from "../api";
import { t } from "../locales/locales";

// 主导航项（可复用）
export const navItems = [
    {key: "dashboard", label: <Link to="/dashboard">{t("nav_dashboard")}</Link>, auth: [AuthTeacher, AuthStudent]},

    {key: "class", label: <Link to="/teacher/class">{t("nav_class")}</Link>, auth: [AuthTeacher]},
    {
        key: "homeworkBank",
        label: <Link to="/teacher/homeworkBank">{t("nav_homeworkBank")}</Link>,
        auth: [AuthTeacher]
    },
    {key: "grade_pending", label: <Link to="/teacher/grade">{t("nav_grade_pending")}</Link>, auth: [AuthTeacher]},
    {key: "files", label: <Link to="/teacher/files">{t("nav_files")}</Link>, auth: [AuthTeacher]},
    {key: "courses", label: <Link to="/teacher/courses">{t("nav_available_tutors")}</Link>, auth: [AuthTeacher]},
    {key: "working", label: <Link to="/teacher/working">{t("nav_working_hours")}</Link>, auth: [AuthTeacher]},


    {key: "stu_class", label: <Link to="/student/class">{t("nav_class")}</Link>, auth: [AuthStudent]},
    {key: "stu_homework", label: <Link to="/student/my_homeworks">{t("nav_my_homework")}</Link>, auth: [AuthStudent]},
];